module.exports = __webpack_public_path__ + "img/logo-2-black.8fe3bdae.png";